import classnames from 'classnames';

import RichText from 'molecules/RichText';

import styles from 'components/ContentEditor/content.module.scss';
import Header from 'components/HealthcareEntries/Header';

import type { ContentEditorProps } from 'components/ContentEditor/config';
import type { FC } from 'react';

const ContentEditor: FC<ContentEditorProps> = ({ eyebrow, heading, firstPublished, body, slug }) => {
  const convertedPublishedDate = firstPublished
    ? new Date(firstPublished).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    : null;

  return (
    <section>
      <article className={styles.background}>
        <div className={styles.spacer} />
        <div className={classnames(styles.main)}>
          <Header slug={slug || null} authors={[]} title={heading || ''} eyebrow={eyebrow} />
          {body && (
            <section className={styles.contentLayout}>
              <div className={styles.contentBodyContainer}>
                <div className={styles.contentLayoutBody}>
                  <div className={styles.builderContent}>
                    <RichText content={body.replace(/\\n/g, '\n')} className={styles.richText} />
                  </div>
                </div>
              </div>
            </section>
          )}

          {convertedPublishedDate && <p className={styles.fullPublishedDate}>{convertedPublishedDate}</p>}
        </div>
        <div className={styles.wrapper} />
      </article>
    </section>
  );
};

export default ContentEditor;
